import { Spinner } from '@blueprintjs/core';
import React from 'react';

import LayerMetadataSummary from 'uf/ui/layers/LayerMetadataSummary/LayerMetadataSummary';

import LayerManagerList from './LayerManagerList/LayerManagerList';
import LayerManagerSearch from './LayerManagerSearch/LayerManagerSearch';
import { useGetProjectAvailableLayersQuery } from 'uf-api-rtk/store/Api';
import { parseFullPath } from 'uf/base/dataset';
import Flex from 'uf/ui/base/Flex';
import { useSelector } from 'react-redux';
import { getActiveProjectId } from 'uf/app/selectors';
import { selectLayerManager } from 'uf/projects/layerManagerSlice';

export default function LayerManager() {
  const { selectedLayerId } = useSelector(selectLayerManager);
  const projectId = useSelector(getActiveProjectId);
  const { namespace, key } = parseFullPath(projectId);
  const { isUninitialized, isSuccess } = useGetProjectAvailableLayersQuery(
    {
      namespace,
      key,
    },
    { skip: !namespace || !key || !projectId },
  );

  if (isUninitialized || !isSuccess) {
    return (
      <Flex justifyContent="center" style={{ minHeight: '20vh' }}>
        <Spinner className="tw-self-center" />
      </Flex>
    );
  }

  return (
    <Flex>
      <Flex
        flexDirection="col"
        style={{ flex: 2, overflow: 'hidden', height: 'calc(70vh - 30px)' }}>
        <LayerManagerSearch />
        <LayerManagerList />
      </Flex>
      <Flex flexDirection="col" alignItems="stretch" style={{ flex: 5 }}>
        <LayerMetadataSummary layerId={selectedLayerId} charLimit={180} />
      </Flex>
    </Flex>
  );
}
